import Reveal from './Reveal';
import SectionHeading from './SectionHeading';
import { topicItems } from '@/mocks/home';

export default function TopicIndex() {
  return (
    <section id="topics" className="border-y border-background-200/70 bg-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-8 md:py-20">
        <Reveal>
          <SectionHeading
            index="04"
            title="爆料风向标"
            subtitle="近 7 天各主题的线报条数与环比变化，用来判断下期该往哪个方向蹲。"
          />
        </Reveal>

        <div className="mt-8 grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-6">
          {topicItems.map((topic, index) => (
            <Reveal key={topic.id} delay={index * 60}>
              <div className="flex h-full flex-col justify-between rounded-lg border border-background-200 bg-background-50 p-4">
                <span className="font-label text-sm font-medium text-foreground-900">
                  {topic.name}
                </span>
                <div className="mt-6">
                  <div className="flex items-baseline gap-1">
                    <span className="font-heading text-2xl font-bold text-foreground-950">
                      {topic.count}
                    </span>
                    <span className="font-label text-xs text-foreground-500">条</span>
                  </div>
                  <span
                    className={`mt-2 inline-flex items-center gap-1 font-label text-xs ${
                      topic.up ? 'text-primary-600' : 'text-foreground-500'
                    }`}
                  >
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i className={topic.up ? 'ri-arrow-up-line' : 'ri-arrow-down-line'} />
                    </span>
                    {topic.trend}
                  </span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}